import { Link } from 'react-router-dom';
import './BlogCard.scss'
import { East } from '@mui/icons-material';


function BlogCard({ image, to, title, desc, allDesc, profilePic,
    profileName, locationPic = undefined, location = undefined, pay = undefined, payUnit = undefined, noDesc = false }) {

    return (
        <div className="blog-card-wrp">
            <Link reloadDocument={true} className='blog-reference' to={to}>
                <div className="blog-board-container">
                    <div className='blog-img-root'>
                        <img className="blog-card-img" src={image} alt='blog-1' />
                        <div className='blog-cntnt-wrp'>
                            {title && <div className="blog-title">{title}</div>}
                            <div className="blog-desc">{desc}</div>
                            <div className="blog-profile-wrp">
                                <img className="blog-profile-img" src={profilePic} alt='profile-pic' />
                                <div className='profile-pay-wrp'>
                                    <div className="profile-name-wrp">
                                        <div className="profile-name">{profileName}</div>
                                        {location && <div className="location-wrp">
                                            <img className="location-img" src={locationPic} alt='location-pic' />
                                            <div className="location-name">{location}</div>
                                        </div>}
                                    </div>
                                    {pay && payUnit && <div className="pay-wrp">
                                        <span className="pay">{pay}/</span><span className="unit">{payUnit}</span>
                                    </div>}
                                </div>
                            </div>
                            {!noDesc && <div className='blog-img-root'>
                                    <div className="blog-all-desc">{allDesc}</div>
                                </div>
                            }

                            {!noDesc && <div className='read-more-wrp'>
                                <div className='read-more'>Read More</div>
                                <East></East>
                            </div>}
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
}

export default BlogCard;